export default __webpack_public_path__ + "static/media/audio_09_vaca.fce13410.mp3";